import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './routes/home/Home.jsx'
import Politics from './routes/politics/Politics.jsx'
import Terms from './routes/terms/Terms.jsx'
import Let from './routes/let/Let.jsx'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/politicas" element={<Politics />} />
        <Route path="/termos" element={<Terms />} />
        <Route path="/let" element={<Let />} />
      </Routes>
    </BrowserRouter>
  );
}